<nav mat-tab-nav-bar [tabPanel]="tabPanel">
	<a
		mat-tab-link
		[routerLink]="['status']"
		routerLinkActive
		#rlaStatus="routerLinkActive"
		[active]="rlaStatus.isActive"
		i18n="@@titleStatus"
	>Status</a>
	<a
		mat-tab-link
		[routerLink]="['diagnostics']"
		routerLinkActive
		#rlaDiag="routerLinkActive"
		[active]="rlaDiag.isActive"
		i18n="@@titleDiagnostics"
	>Diagnostics</a>
	<a
		mat-tab-link
		[routerLink]="['settings-user']"
		routerLinkActive
		#rlaSettUser="routerLinkActive"
		[active]="rlaSettUser.isActive"
		i18n="@@titleUserSettings"
	>User Settings</a>
	<a
		mat-tab-link
		[routerLink]="['settings-solar']"
		routerLinkActive
		#rlaSettSolar="routerLinkActive"
		[active]="rlaSettSolar.isActive"
		i18n="@@titleSolarSettings"
	>Solar Settings</a>
	<a
		mat-tab-link
		[routerLink]="['settings-charge-schedule']"
		routerLinkActive
		#rlaSettChaSche="routerLinkActive"
		[active]="rlaSettChaSche.isActive"
		i18n="@@titleChargeScheduleSettings"
	>Charge Schedule Settings</a>

	<a 
		mat-tab-link 
		[routerLink]="['settings-installer']"
		routerLinkActive
		#rlaSettInst="routerLinkActive"
		[active]="rlaSettInst.isActive"
		i18n="@@titleInstallerSettings"
	>Installer Settings</a>
	<span
		matTooltip="Only DSO installers can add chargers"
		[matTooltipDisabled]="authService.isInstallerDSO()"
		i18n-matTooltip
	>
		<a 
			mat-tab-link
			[routerLink]="['settings-installer-dso']"
			routerLinkActive
			#rlaSettInstDso="routerLinkActive"
			[active]="rlaSettInstDso.isActive"
			[disabled]="!authService.isInstallerDSO()"
			i18n="@@titleInstallerDSOSettings"
		>Installer DSO Settings</a>
	</span>
	<a 
		mat-tab-link 
		[routerLink]="['settings-installer-ocpp']"
		routerLinkActive
		#rlaSettInstOcpp="routerLinkActive"
		[active]="rlaSettInstOcpp.isActive"
		i18n="@@titleInstallerOCPPSettings"
	>Installer OCPP Settings</a>
</nav>
<mat-tab-nav-panel #tabPanel>
    <router-outlet></router-outlet>
</mat-tab-nav-panel>
